<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-popup class="holamundo" title="Kampanya Sil" :active.sync="deletePopupActive" v-esc="escape">
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Kampanyayı Silmek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç</vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="removeCampaign(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <new-campaign ref="newCampaign" @success="reloadData" />
    <vs-row vs-type="flex" vs-w="12" id="campaignPageHeader">
      <vx-tooltip v-if="$isCenterBranch() && isNewCampaignPermission" text="Yeni Kampanya" position="top">
        <vs-button @click="openNewCampaignPage" class="panel-action text-success xlarge-button panel-action-box-shadow"
          color="transparent" icon-pack="feather" icon="icon-plus">
        </vs-button>
      </vx-tooltip>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="campaignPageContent">
      <vs-row vs-type="flex" vs-w="12" id="campaignList">
        <vs-col vs-type="flex" class="campaingItem" v-for="campaign in campaigns" :key="campaign.id">
          <vs-row vs-type="block" vs-w="12">
            <vs-row class="campaignTitle py-1" vs-type="flex" vs-w="12">
              <vx-tooltip :text="campaign.title" color="primary" position="top" class="w-full flex">
              <span class="text-small text-primary bold">
                {{campaign.title}}
              </span>
              </vx-tooltip>
            </vs-row>
            <vs-row class="border-all" vs-type="flex" vs-w="12" style="background-color:#00000070;position: relative;">
              <div class="campaignImgDiv m-auto">
                <img :src="$baseUrl + '/' + campaign.image" alt="img" class="responsive">
              </div>
              <span class="text-smaller py-1 px-2 campaignDescription text-white weight-600">
                {{campaign.description}}
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="border-all px-2">
              <vs-row vs-type="flex" vs-w="12" class="mt-2">
                <span class="text-smaller text-dark weight-600 mr-auto">
                  {{campaign.usedBy}} kez
                </span>
                <span class="text-smaller text-dark weight-600 ml-auto">
                  {{campaign.totalUsageLimit ? campaign.totalUsageLimit + ' kez' : 'Sınırsız'}}
                </span>
                <vx-tooltip v-if="campaign.totalUsageLimit" :text="'Kalan Kullanım : ' + (campaign.totalUsageLimit - campaign.usedBy).toString() "
                  color="primary" position="top" class="w-full">
                  <vs-progress :height="8" :percent="campaign.usedBy * 100 / campaign.totalUsageLimit"
                    :color="campaign.usedBy == campaign.totalUsageLimit ? 'danger' : 'success'">
                  </vs-progress>
                </vx-tooltip>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="my-1">
                <span class="text-smaller text-dark weight-600 mr-auto">
                  {{formatDate(campaign.startDate)}}
                </span>
                <span class="text-smaller text-dark weight-600 ml-auto">
                  {{formatDate(campaign.endDate)}}
                </span>
                <vx-tooltip :text="campaign.leftTime" color="primary" position="top" class="w-full">
                  <vs-progress :height="8" :percent="campaign.toFinish"
                    :color="campaign.toFinish == 100 ? 'danger' : 'success'">
                  </vs-progress>
                </vx-tooltip>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="py-2">
                <vx-tooltip v-show="$isCenterBranch()" :text="campaign.isMoodFelek ? 'Moodfelekte Gösteriliyor !' : 'Moodfelekte Gösterilmiyor'" color="primary"
                  position="top">
                  <vs-button :disabled="campaign.isPublished"
                    icon-pack="feather" icon="icon-chrome" :color="campaign.isMoodFelek ? 'success' : 'danger'" />
                </vx-tooltip>
                <vx-tooltip :text="campaign.isPublished ? ($isCenterBranch() ? 'Yayından Kaldır !' : 'Yayında') : ($isCenterBranch() ? 'Yayınla !' : 'Yayında Değil')" color="primary"
                  position="top">
                  <vs-button :disabled="!$isCenterBranch()" @click="setCampaignPublish(campaign.id)" class="ml-1" icon-pack="feather"
                    icon="icon-monitor" :color="campaign.isPublished ? 'success' : 'danger'" />
                </vx-tooltip>
                <vx-tooltip v-show="$isCenterBranch()" class="ml-auto" text="Sil" color="primary" position="top">
                  <vs-button :disabled="campaign.isPublished || campaign.isPrivate || campaign.isMoodFelek" @click="deletePopupActive = true;deletedId = campaign.id;"
                    icon-pack="feather" icon="icon-trash" color="danger" />
                </vx-tooltip>
                <vx-tooltip class="ml-1" text="Ayarlar" color="primary" position="top">
                  <vs-button @click="editCampaign(campaign.id)" icon-pack="feather"
                    icon="icon-settings" color="primary" />
                </vx-tooltip>
              </vs-row>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-row>
</template>

<script>
  import NewCampaign from "./NewCampaign";
  import {
    GetAllCampaigns,
    SetCampaignMoodfelek,
    SetCampaignPublish,
    DeleteCampaign
  } from "@/api/Campaign";
  import {isGranted} from "@/utils/auth";
  export default {
    data() {
      return {
        campaigns: [],
        tableOptions: {},
        deletePopupActive: false,
        deletedId: null
      }
    },
    components: {
      NewCampaign
    },
    computed: {
      isNewCampaignPermission(){
      return isGranted("campaign_write")
    }
    },
    methods: {
      escape() {
        if (this.deletePopupActive) {
          this.deletePopupActive = false;
          this.deletedId = null;
        }
      },
      removeCampaign(campaignId) {
        DeleteCampaign(campaignId).then(res => {
          if (res && res.status) {
            this.deletePopupActive = false;
            this.deletedId = null;
            let index = this.campaigns.findIndex(x => x.id == campaignId);
            this.campaigns.splice(index, 1);
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'Kampanya Silme İşlemi Başarılı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya Silme İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      setCampaignPublish(campaignId) {
        SetCampaignPublish(campaignId).then(res => {
          if (res && res.status == 200) {
            this.campaigns.find(x => x.id == campaignId).isPublished = res.data;
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı',
              text: res.data ? 'Kampanya Yayına Alındı !' : 'Kampanya Yayından Çıkarıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      setCampaignMoodfelek(campaignId) {
        SetCampaignMoodfelek(campaignId).then(res => {
          if (res && res.status == 200) {
            this.campaigns.find(x => x.id == campaignId).isMoodFelek = res.data;
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı',
              text: res.data ? 'Kampanya Moodfelek\'e Eklendi !' : 'Kampanya Moodfelek\'den Çıkarıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      editCampaign(campaignId) {
        this.$refs.newCampaign.loadNewCampaign(campaignId);
      },
      formatDate(formatDate) {
        let dateTime = formatDate.split("T");
        return dateTime[0] + " " + dateTime[1].substring(0, 5);
      },
      openNewCampaignPage() {
        this.$refs.newCampaign.isActive = true;
      },
      reloadData() {
        this.GetAllCampaigns();
      },
      GetAllCampaigns() {
        GetAllCampaigns(this.tableOptions).then(res => {
          if (res && res.status == 200) {
            this.campaigns = res.data.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanyalar Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      }
    },
    watch: {
      tableOptions: {
        deep: true,
        handler() {
          this.GetAllCampaigns();
        }
      }
    },
    created() {
      this.tableOptions = {
        campaignId: null,
        title: null,
        description: null,
        startDate: null,
        endDate: null,
        isPublished: null,
        isMoodFelek: null
      };
    }
  }

</script>

<style>
 
  .campaignImgDiv {
    filter: brightness(55%);
    height: 22.5vh;
    overflow: hidden;
    min-height: 150px;
    position: relative;
  }

  .campaignDescription {
    position: absolute;
    height: 22.5vh;
    overflow: hidden;
    text-shadow: 1px 1px rgba(var(--vs-primary), 1);
  }

  .campaignTitle {
    border-radius: 8px;
  }

  .campaignTitle span{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

</style>
